import IMapEventListenerParams, { IGmapStreetView } from '~/components/map/types/IMapEventListenerParams';
import IMapSzukajServiceConfig from '~/components/map/types/IMapSzukajServiceConfig';

const addEventListenerToStreetViewModeChanged = (params: IMapEventListenerParams<IMapSzukajServiceConfig>): void => {
  const { gmap, serviceConfig } = params;
  const streetView: IGmapStreetView = gmap.getStreetView();

  google.maps.event.addListener(streetView, 'visible_changed', () => {
    serviceConfig.config.streetViewIsVisible = streetView.getVisible();
  });
};
export default addEventListenerToStreetViewModeChanged;
